<template>
  <div id="EscrowInstrumentSelectModal">
    <div
      class="modal-card"
      style="
        width: 1300px;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
      "
    >
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke">注文内容確認</p>
      </header>
      <section class="modal-card-body">
        <span
          >以下の内容でWEB/HTへ連携します。<br />お間違いなければ、確定ボタンを押してください。</span
        >
        <div class="condition-area">
          <table class="conditionTable" style="margin-bottom: 10px">
            <tr>
              <th>受付番号</th>
              <td>{{ detailObj.receiptNumber }}</td>
              <th>対象顧客</th>
              <td>
                {{ detailObj.targetHospitalName }}&nbsp;&nbsp;{{
                  detailObj.ordererName
                }}
              </td>
            </tr>
            <tr>
              <th>得意先区分</th>
              <td>{{ detailObj.customerClass }}</td>
              <th>診療科コード</th>
              <td>{{ detailObj.departmentCode }}</td>
            </tr>
            <tr>
              <th>配送先</th>
              <td colspan="3">
                〒{{ detailObj.deliveryPostcode }}&nbsp;&nbsp;{{
                  detailObj.deliveryAddress1
                }}{{ detailObj.deliveryAddress2
                }}{{ detailObj.deliveryAddress3 }}
              </td>
            </tr>
          </table>
          <!-- 注文する品をまとめて表示-->
          <template>
            <div>
              <!-- 器械テーブル -->
              <table v-if="orderDevice">
                <tr>
                  <thead>
                    <th style="width: 400px">器械</th>
                    <th style="width: 80px; text-align: center">個数</th>
                    <th style="width: 200px; text-align: center">見積番号</th>
                    <th style="width: 250px; text-align: center">
                      見積詳細番号
                    </th>
                    <th style="width: 100px; text-align: center">納入価</th>
                    <th style="width: 100px; text-align: center">見積日</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowDeviceList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 400px">
                      {{ detailObj.escrowDeviceList[index].itemCode }} :
                      {{ detailObj.escrowDeviceList[index].itemName }}
                    </td>
                    <td style="width: 80px; text-align: center">
                      {{ detailObj.escrowDeviceList[index].quantity }}
                    </td>
                    <td style="width: 200px; text-align: center">
                      {{ detailObj.escrowDeviceList[index].quotationNumber }}
                    </td>
                    <td style="width: 250px; text-align: center">
                      {{
                        detailObj.escrowDeviceList[index].quotationDetailsNumber
                      }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowDeviceList[index].deliveryPrice }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{
                        detailObj.escrowDeviceList[index]
                          .latestOrderRegisteredDate
                      }}
                    </td>
                  </tbody>
                </tr>
              </table>
              <!-- マスクテーブル -->
              <table v-if="orderMask" style="margin-top: 10px">
                <tr>
                  <thead>
                    <th style="width: 400px">マスク</th>
                    <th style="width: 80px; text-align: center">個数</th>
                    <th style="width: 200px; text-align: center">見積番号</th>
                    <th style="width: 250px; text-align: center">
                      見積詳細番号
                    </th>
                    <th style="width: 100px; text-align: center">納入価</th>
                    <th style="width: 100px; text-align: center">見積日</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowMaskList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 400px">
                      {{ detailObj.escrowMaskList[index].itemCode }} :
                      {{ detailObj.escrowMaskList[index].itemName }}
                    </td>
                    <td style="width: 80px; text-align: center">
                      {{ detailObj.escrowMaskList[index].quantity }}
                    </td>
                    <td style="width: 200px; text-align: center">
                      {{ detailObj.escrowMaskList[index].quotationNumber }}
                    </td>
                    <td style="width: 250px; text-align: center">
                      {{
                        detailObj.escrowMaskList[index].quotationDetailsNumber
                      }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowMaskList[index].deliveryPrice }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{
                        detailObj.escrowMaskList[index]
                          .latestOrderRegisteredDate
                      }}
                    </td>
                  </tbody>
                </tr>
              </table>
              <!-- 用品テーブル -->
              <table v-if="orderOption" style="margin-top: 20px">
                <tr>
                  <thead>
                    <th style="width: 400px">用品</th>
                    <th style="width: 80px; text-align: center">個数</th>
                    <th style="width: 200px; text-align: center">見積番号</th>
                    <th style="width: 250px; text-align: center">
                      見積詳細番号
                    </th>
                    <th style="width: 100px; text-align: center">納入価</th>
                    <th style="width: 100px; text-align: center">見積日</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowOptionItemList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 400px">
                      {{ detailObj.escrowOptionItemList[index].itemCode }} :
                      {{ detailObj.escrowOptionItemList[index].itemName }}
                    </td>
                    <td style="width: 80px; text-align: center">
                      {{ detailObj.escrowOptionItemList[index].quantity }}
                    </td>
                    <td style="width: 200px; text-align: center">
                      {{
                        detailObj.escrowOptionItemList[index].quotationNumber
                      }}
                    </td>
                    <td style="width: 250px; text-align: center">
                      {{
                        detailObj.escrowOptionItemList[index]
                          .quotationDetailsNumber
                      }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowOptionItemList[index].deliveryPrice }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{
                        detailObj.escrowOptionItemList[index]
                          .latestOrderRegisteredDate
                      }}
                    </td>
                  </tbody>
                </tr>
              </table>
              <!-- 同梱品テーブル -->
              <table v-if="orderBundle" style="margin-top: 20px">
                <tr>
                  <thead>
                    <th style="width: 500px">同梱品</th>
                    <th style="width: 100px; text-align: center">個数</th>
                  </thead>
                </tr>
                <tr
                  v-for="(item, index) in detailObj.escrowBundleItemList"
                  :key="index"
                >
                  <tbody>
                    <td style="width: 500px">
                      {{ detailObj.escrowBundleItemList[index].itemCode }} :
                      {{ detailObj.escrowBundleItemList[index].itemName }}
                    </td>
                    <td style="width: 100px; text-align: center">
                      {{ detailObj.escrowBundleItemList[index].quantity }}
                    </td>
                  </tbody>
                </tr>
              </table>
            </div>
          </template>
          <div
            class="searchButton-area"
            style="margin-top: 15px; text-align: center"
          >
            <b-button class="is-primary" @click="completed">確定</b-button>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          閉じる
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "EscrowInstrumentSelectModal",
  props: {
    detailObj: {},
    userInfo: {},
  },
  methods: {
    completed: function () {
      this.detailObj.userInfo = this.userInfo;
      this.$emit("requestCpapAfterConfirm", this.detailObj);
      this.$parent.close();
    },
  },
  data() {
    return {
      orderDevice: false,
      orderMask: false,
      orderOption: false,
      orderBundle: false,
    };
  },
  filters: {},
  components: {},
  mounted: function () {
    // 表示判断
    if (
      this.detailObj.escrowDeviceList.length > 0 &&
      this.detailObj.escrowDeviceList[0].itemCode
    ) {
      this.orderDevice = true;
    }
    if (
      this.detailObj.escrowMaskList.length > 0 &&
      this.detailObj.escrowMaskList[0].itemCode
    ) {
      this.orderMask = true;
    }
    if (
      this.detailObj.escrowOptionItemList.length > 0 &&
      this.detailObj.escrowOptionItemList[0].itemCode
    ) {
      this.orderOption = true;
    }
    if (
      this.detailObj.escrowBundleItemList.length > 0 &&
      this.detailObj.escrowBundleItemList[0].itemCode
    ) {
      this.orderBundle = true;
    }
  },
};
</script>
<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/EscrowInstrumentSelectModal.vue